var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1710_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0498453 7.64692C-0.0166143 7.77984 -0.0166144 7.97922 0.0498453 8.1786C0.116304 8.24506 0.116304 8.31151 0.182764 8.37797L6.03115 14.1599C6.29699 14.4257 6.69574 14.4257 6.96158 14.1599C7.22741 13.8941 7.22741 13.4953 6.96158 13.2295L2.24299 8.51089L15.3354 8.51089C15.7342 8.51089 16 8.24506 16 7.8463C16 7.44755 15.7342 7.18171 15.3354 7.18171L2.30945 7.18171L7.02804 2.46313C7.29387 2.19729 7.29387 1.79854 7.02804 1.5327C6.89512 1.39978 6.69574 1.33332 6.56283 1.33332C6.42991 1.33332 6.23053 1.39978 6.09761 1.5327L0.249221 7.38109C0.182763 7.44755 0.116304 7.51401 0.0498453 7.64692Z",
    fill: "#031D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1710_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.c14e2d46ce03775b439253de92bf6b17.svg";
export { ForwardRef as ReactComponent };